export default __webpack_public_path__ + "static/media/NEPAR-logo.f40c0458.svg";